<template>
  <article class="mobile-service-overview">
    <header class="mobile-service-overview__hero">
      <img class="mobile-service-overview__hero-image" :src="heroImage" alt="" aria-hidden="true" />
      <p class="mobile-service-overview__eyebrow">{{ eyebrow }}</p>
      <h1 class="mobile-service-overview__title">{{ title }}</h1>
      <p class="mobile-service-overview__summary">{{ summary }}</p>
    </header>

    <div class="mobile-service-overview__content">
      <section class="mobile-service-overview__metrics" aria-label="关键数据">
        <h2 class="mobile-service-overview__section-title">关键数据</h2>
        <div class="mobile-service-overview__metric-grid">
          <article v-for="metric in metrics" :key="metric.label" class="mobile-service-overview__metric-card">
            <strong class="mobile-service-overview__metric-value">{{ metric.value }}</strong>
            <span class="mobile-service-overview__metric-label">{{ metric.label }}</span>
          </article>
        </div>
      </section>

      <section class="mobile-service-overview__highlights" aria-label="核心能力">
        <h2 class="mobile-service-overview__section-title">核心能力</h2>
        <article v-for="highlight in highlights" :key="highlight.title" class="mobile-service-overview__highlight-card">
          <span class="mobile-service-overview__highlight-kicker">{{ highlight.kicker }}</span>
          <h3 class="mobile-service-overview__highlight-title">{{ highlight.title }}</h3>
          <p class="mobile-service-overview__highlight-description">{{ highlight.description }}</p>
        </article>
      </section>
    </div>
  </article>
</template>

<script>
export default {
  name: 'MobileServiceOverview',
  props: {
    eyebrow: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    summary: {
      type: String,
      required: true
    },
    heroImage: {
      type: String,
      required: true
    },
    metrics: {
      type: Array,
      required: true
    },
    highlights: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="css" src="@/assets/styles/components/mobile-service-overview.css" />
